import React from "react"

import { Provider } from "react-redux";
import { createStore, compose, applyMiddleware, combineReducers } from 'redux';
import ReduxThunk from 'redux-thunk' // no changes here 😀
import LocalStorageHelper from 'components/common/helpers/LocalStorageHelper';

import reducer from './reducer';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './assets/scss/default.scss';
import { STANDARD } from 'components/common/constants/authConstants';
import { library } from '@fortawesome/fontawesome-svg-core';
import { far } from '@fortawesome/fontawesome-free-regular';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas, faCheckSquare, faCoffee, faEnvelope, faAngleLeft } from '@fortawesome/free-solid-svg-icons';

library.add(fab, fas, faCheckSquare, faCoffee, faEnvelope, faAngleLeft);

import AppRouter from './AppRouter';

import auth from './reducers/authReducer';
import booking from './reducers/bookingReducer';
import service from './reducers/serviceReducer';

//import DEV library only in DEV environment
if (process.env.NODE_ENV !== "production") {
  var reduxLogger = require('redux-logger');
}

class App extends React.Component {

  render() {
    var { path, seo, locale, ...serverProps } = this.props;
    var noWindow = (typeof window === 'undefined');
    var composeEnhancers = compose;

    var middleware = [];
    middleware.push(ReduxThunk);
    if (process.env.NODE_ENV !== "production") {
      middleware.push(reduxLogger.createLogger());
      if (!noWindow) {
        composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
          window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;
      }
    }

    const combinedReducers = combineReducers(
      {
        app: reducer,
        auth,
        booking,
        service
      }
    );

    const enhancer = composeEnhancers(
      applyMiddleware(...middleware)
    );

    if (!noWindow) {
      LocalStorageHelper.setLocale(locale);
    }

    const store = createStore(
      combinedReducers,
      { //initial state
        app: {
          seo: seo,
          locale: locale,
          isLogged: serverProps.isLogged,
        }
      },
      enhancer
    );

    if (!noWindow) {
      window.isInitialLoad = true;
      if (window.Cypress) {
        window.store = store
      }
    }

    return (
      <Provider store={store}>
        <AppRouter {...this.props} serverProps={serverProps} />
      </Provider>
    );
  }
}

export default App;
